<template>
  <v-container fluid>
    <!-- Buscador -->
    <v-text-field
      v-model="search"
      label="Buscar en exclusiones..."
      prepend-icon="mdi-magnify"
      outlined
      dense
      clearable
      hide-details
      class="mb-4"
    />

    <v-card class="pa-4 mb-2" outlined>
      <div class="text-h6 font-weight-bold">
        Exclusiones para el área de urgencias médicas
      </div>
    </v-card>

    <!-- Secciones agrupadas -->
    <v-expansion-panels multiple accordion class="mt-2">
      <v-expansion-panel
        v-for="(cat, idx) in filteredCategories"
        :key="idx"
      >
        <v-expansion-panel-header>
          <div class="d-flex align-center justify-space-between w-100">
            <span class="font-weight-medium">{{ cat.title }}</span>
            <v-chip x-small outlined>
              {{ cat.items.length }}
            </v-chip>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-list dense>
            <v-list-item
              v-for="(it, i) in cat.items"
              :key="i"
              class="py-2"
            >
              <v-list-item-content>
                <v-list-item-title v-html="highlight(it.title)"/>
                <v-list-item-subtitle v-if="it.note" v-html="highlight(it.note)"/>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Nota -->
    <!-- <v-alert type="info" dense outlined class="mt-4">
      Para más información, consulta tu contrato personal.
    </v-alert> -->
  </v-container>
</template>

<script>
export default {
  name: "ExclusionesUrgenciasView",
  data() {
    return {
      search: "",
      categories: [
        {
          title: "1. Diagnósticos y estudios no cubiertos",
          items: [
            {
              title: "Resonancia Magnética y Tomografía Axial Computarizada",
              note: "Incluso si son solicitadas en urgencias."
            },
            {
              title: "Pruebas diagnósticas para COVID-19 e influenza",
              note: "Incluso si son solicitadas en urgencias."
            },
            {
              title: "Endoscopias y colonoscopias",
              note: "Y estudios de motilidad gastrointestinal."
            },
            {
              title: "Estudios no relacionados con el padecimiento reclamado",
              note: "O que no demuestren enfermedad."
            },
            {
              title: "Chequeos médicos",
              note: "No se cubren revisiones generales sin urgencia."
            }
          ]
        },
        {
          title: "2. Tratamientos y condiciones no cubiertas",
          items: [
            {
              title: "Tratamientos o procedimientos por padecimientos preexistentes",
              note: "(Salvo que sean accidentes o condiciones cubiertas expresamente)."
            },
            {
              title: "Tratamientos por padecimientos congénitos",
              note: "(Incluye malformaciones o condiciones presentes desde el nacimiento)."
            },
            {
              title: "Cirugías o tratamientos estéticos/plásticos",
              note: "(Incluye procedimientos con fines estéticos, dietéticos u obesidad)."
            },
            {
              title: "Uso o consumo de drogas o alcohol",
              note: "Atención en urgencias derivada de intoxicación o consumo."
            },
            {
              title: "Intento de suicidio",
              note: "Atención médica por cualquier intento autolesivo."
            },
            {
              title: "Atención obstétrica",
              note: "Incluye parto, cesárea y complicaciones del embarazo."
            },
            {
              title: "Atención ginecológica y/o embarazo",
              note: "Incluso complicaciones."
            },
            {
              title: "Aparatos ortopédicos",
              note: "Ej. sillas de ruedas, collarines duros, rodilleras mecánicas."
            },
            {
              title: "Diálisis crónica",
              note: "Diálisis peritoneal o hemodiálisis de forma continua."
            },
            {
              title: "Tratamientos por VIH/SIDA",
              note: "Incluye todas las enfermedades relacionadas."
            },
            {
              title: "Trastornos psiquiátricos o psicológicos",
              note: "Ej. depresión, psicosis, estrés, anorexia, bulimia, trastornos del sueño."
            }
          ]
        },
        {
          title: "3. Servicios y situaciones adicionales no cubiertas",
          items: [
            {
              title: "Consultas particulares o a domicilio",
              note: "No se cubre si no es dentro de la red hospitalaria."
            },
            {
              title: "Consulta en urgencias solo para receta",
              note: "Si no hay procedimiento o tratamiento, debe pagarla el paciente."
            },
            {
              title: "Surtido de recetas",
              note: "Recetas otorgadas en urgencias sin procedimiento o tratamiento."
            },
            {
              title: "Transporte en ambulancia",
              note: "No está incluido dentro de urgencias."
            },
            {
              title: "Transfusiones sanguíneas",
              note: null
            }
          ]
        }
      ]
    };
  },
  computed: {
    filteredCategories() {
      if (!this.search) return this.categories;

      const term = this.search.trim().toLowerCase();
      return this.categories
        .map(cat => {
          const items = cat.items.filter(it =>
            (it.title || "").toLowerCase().includes(term) ||
            (it.note || "").toLowerCase().includes(term)
          );
          return { ...cat, items };
        })
        .filter(cat => cat.items.length > 0);
    }
  },
  methods: {
    highlight(text) {
      if (!text || !this.search) return text;
      const esc = this.escapeRegExp(this.search.trim());
      const re = new RegExp(`(${esc})`, "ig");
      return text.replace(re, "<mark>$1</mark>");
    },
    escapeRegExp(s) {
      return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
  }
};
</script>

<style scoped>
/* Opcional: mejora la legibilidad */
mark {
  padding: 0 .15em;
  border-radius: 2px;
}
</style>
